import styled from '@emotion/styled';
import { Box } from '@lightspeed/flame/Core';
import { Modal } from '@lightspeed/flame/Modal';
import { Radio } from '@lightspeed/flame/Radio';

export const StyledModal = styled(Modal)`
  max-width: 420px;
  width: 420px;
`;

export const MaxSizedImage = styled('img')`
  object-fit: cover;
  max-height: 300px;
  width: 100%;
  max-width: 150px;
`;

export const StyledSpinnerWrapper = styled(Box)`
  position: absolute;
  bottom: 30px;
  right: 30px;
  background-color: white;
  border: 2px solid white;
  border-radius: 100%;
`;
export const StyledRadio = styled(Radio)`
  cursor: pointer;
`;
